import {
  MessageConfig, MessageType, NotificationConfig, NotificationType,
} from '@routific/hive';
import i18n from '../../i18n';
import { UNKNOWN_STOP } from './constants';

export const getUnschedulingStopMessageKey = (visitId: string): string => `unscheduling-stop-${visitId}`;

export const unschedulingStopMessage = (visitId: string, visitName?: string | null, targetName?: string | null): MessageConfig => ({
  key: getUnschedulingStopMessageKey(visitId),
  type: MessageType.LOADING,
  content: `Unscheduling ${visitName || UNKNOWN_STOP} from ${targetName || 'Unknown'}...`,
  dataCy: 'unscheduling-stop-message',
  duration: 0,
});

export const unscheduleStopFailedNotification = (visitId: string, visitName?: string | null, targetName?: string | null, onViewStop?: () => void): NotificationConfig => ({
  id: `unschedule-stop-${visitId}-failure`,
  type: NotificationType.ERROR,
  message: `Couldn't unschedule ${visitName || UNKNOWN_STOP} from ${targetName || 'Unknown'}. Please try again in a few minutes.`,
  linkMessage: onViewStop ? 'View Stop' : undefined,
  linkOnClick: onViewStop,
});

export const unscheduleStopsFailedNotification = (): NotificationConfig => ({
  id: 'unschedule-stops-failure',
  type: NotificationType.ERROR,
  message: `${i18n.t('notifications:unscheduleStops.failure.message')}`,
});

export const unscheduleStopSuccessNotification = (visitId: string, visitName?: string | null, targetName?: string | null, onViewStop?: () => void): NotificationConfig => ({
  id: `unschedule-stop-${visitId}-success`,
  type: NotificationType.SUCCESS,
  message: `Unscheduled ${visitName || UNKNOWN_STOP} from ${targetName || 'Unknown'}.`,
  linkMessage: onViewStop ? 'View Stop' : undefined,
  linkOnClick: onViewStop,
  dataCy: 'unscheduled-stop-success-notification',
});
